import { Dispatch, ReactNode, SetStateAction, useCallback, useEffect } from 'react';
import { Client } from '../../services/typings';
import { fetchClientWithRetry } from './helper';
import * as serialService from '../../services/serial';
// @ts-ignore
import confirmSound from '../../assets/sounds/state-change_confirm-up.wav';
import { DeviceInputData } from '../../services/serial';

export const CONFIRM_AUDIO_SOUND = new Audio(confirmSound);

const MIN_BADGE_READ_INTERVAL_MS = 2000;
let lastReadTime = 0;

export function resetBadgeReadTime(): void {
  lastReadTime = 0;
}

export interface UseBadgeReaderOptions {
  changeClient(client: Client | null): void;
  setSnackBarMessage: Dispatch<SetStateAction<ReactNode>>;
  warehouseId: number;
}

export function useBadgeReader({
  changeClient,
  setSnackBarMessage,
  warehouseId,
}: UseBadgeReaderOptions): void {
  const onCodeRead = useCallback(
    async (inputData: DeviceInputData): Promise<void> => {
      const now = Date.now();
      if (now - lastReadTime < MIN_BADGE_READ_INTERVAL_MS) {
        return;
      }
      lastReadTime = now;

      let snackMessage;
      let client: Client | null;
      if (inputData.codeType === 'qrcode') {
        snackMessage = 'QR Code reconnu.';
      } else if (inputData.deviceType === 'DEISTER_BADGE_READER') {
        snackMessage = 'Badge CA reconnu.';
      } else {
        snackMessage = 'Badge reconnu.';
      }
      setSnackBarMessage(snackMessage);

      try {
        await CONFIRM_AUDIO_SOUND.play();
        client = await fetchClientWithRetry(inputData, warehouseId);

        if (client) {
          changeClient(client);
          if (client.hasPendingTransations) {
            setSnackBarMessage(
              "Attention: le client a une ou plusieurs transactions dont le paiement n'a pas abouti",
            );
          }
        } else {
          setSnackBarMessage('Impossible de trouver le client, réessayez.');
        }
      } catch (err) {
        setSnackBarMessage(`Erreur lors de la récupération du client : ${err.message}`);
      }
    },

    [setSnackBarMessage, changeClient],
  );

  useEffect(() => {
    serialService.addListener(onCodeRead);
    return () => serialService.removeListener(onCodeRead);
  }, []);
}
